import React from 'react'

import Button from '../../../components/Button/Button'
import Modal from '../../../components/Modal/Modal'
import Switch from '../../../components/Switch/Switch'

function CategoryRow({ label, enabled, value, onValueChange, valueLabel, placeholder }) {
  if (!enabled) return null
  return (
    <label className="kampdag-admin-field">
      <div className="kampdag-admin-label">{valueLabel || label}</div>
      <input
        className="kampdag-admin-input"
        type="number"
        min={0}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
      />
    </label>
  )
}

function KampdagMatchModal({
  isOpen,
  onClose,
  form,
  setForm,
  onSubmit,
  saving,
}) {
  const update = (patch) => setForm((p) => ({ ...p, ...patch }))

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={form.id ? 'Redigér kampdag' : 'Ny kampdag'}
      size="medium"
      className="kampdag-admin-modal"
    >
      <div className="kampdag-admin-form">
        <label className="kampdag-admin-field">
          <div className="kampdag-admin-label">Titel</div>
          <input
            className="kampdag-admin-input"
            type="text"
            placeholder="fx Champions League finale 2026"
            value={form.title}
            onChange={(e) => update({ title: e.target.value })}
          />
        </label>

        <label className="kampdag-admin-field">
          <div className="kampdag-admin-label">Tidspunkt</div>
          <input
            className="kampdag-admin-input"
            type="datetime-local"
            value={form.kickoffLocal}
            onChange={(e) => update({ kickoffLocal: e.target.value })}
          />
        </label>

        <div className="kampdag-admin-row">
          <label className="kampdag-admin-field">
            <div className="kampdag-admin-label">Hjemmehold</div>
            <input
              className="kampdag-admin-input"
              type="text"
              placeholder="fx FC København"
              value={form.homeTeam}
              onChange={(e) => update({ homeTeam: e.target.value })}
            />
          </label>
          <label className="kampdag-admin-field">
            <div className="kampdag-admin-label">Udehold</div>
            <input
              className="kampdag-admin-input"
              type="text"
              placeholder="fx FC Midtjylland"
              value={form.awayTeam}
              onChange={(e) => update({ awayTeam: e.target.value })}
            />
          </label>
        </div>

        <div className="kampdag-admin-row">
          <label className="kampdag-admin-field">
            <div className="kampdag-admin-label">Sted</div>
            <input
              className="kampdag-admin-input"
              type="text"
              placeholder="fx Parken"
              value={form.venue}
              onChange={(e) => update({ venue: e.target.value })}
            />
          </label>
          <label className="kampdag-admin-field">
            <div className="kampdag-admin-label">By</div>
            <input
              className="kampdag-admin-input"
              type="text"
              placeholder="fx København"
              value={form.city}
              onChange={(e) => update({ city: e.target.value })}
            />
          </label>
        </div>

        <div className="kampdag-admin-categories">
          <div className="kampdag-admin-label">Der spilles på</div>
          <div className="kampdag-admin-categories__grid">
            <div className="kampdag-admin-toggle">
              <span>Resultat (mål)</span>
              <Switch checked={form.enableResult} onChange={(v) => update({ enableResult: v })} />
            </div>
            <div className="kampdag-admin-toggle">
              <span>Antal gule kort</span>
              <Switch checked={form.enableYellowCards} onChange={(v) => update({ enableYellowCards: v })} />
            </div>
            <div className="kampdag-admin-toggle">
              <span>Antal røde kort</span>
              <Switch checked={form.enableRedCards} onChange={(v) => update({ enableRedCards: v })} />
            </div>
            <div className="kampdag-admin-toggle">
              <span>Antal hjørnespark</span>
              <Switch checked={form.enableCorners} onChange={(v) => update({ enableCorners: v })} />
            </div>
          </div>
        </div>

        {(form.enableResult || form.enableYellowCards || form.enableRedCards || form.enableCorners) && (
          <div className="kampdag-admin-results">
            <div className="kampdag-admin-label">Faktiske resultater (kan udfyldes senere)</div>
            {form.enableResult && (
              <div className="kampdag-admin-row">
                <CategoryRow
                  label="Hjemme mål"
                  enabled
                  value={form.homeScore}
                  onValueChange={(v) => update({ homeScore: v })}
                  valueLabel="Hjemme mål"
                  placeholder="0"
                />
                <CategoryRow
                  label="Ude mål"
                  enabled
                  value={form.awayScore}
                  onValueChange={(v) => update({ awayScore: v })}
                  valueLabel="Ude mål"
                  placeholder="0"
                />
              </div>
            )}
            <CategoryRow
              label="Gule kort"
              enabled={form.enableYellowCards}
              value={form.yellowCards}
              onValueChange={(v) => update({ yellowCards: v })}
              valueLabel="Gule kort i alt"
              placeholder="0"
            />
            <CategoryRow
              label="Røde kort"
              enabled={form.enableRedCards}
              value={form.redCards}
              onValueChange={(v) => update({ redCards: v })}
              valueLabel="Røde kort i alt"
              placeholder="0"
            />
            <CategoryRow
              label="Hjørnespark"
              enabled={form.enableCorners}
              value={form.corners}
              onValueChange={(v) => update({ corners: v })}
              valueLabel="Hjørnespark i alt"
              placeholder="0"
            />
          </div>
        )}

        <div className="kampdag-admin-form__actions">
          <Button title="Annuller" variant="outlined" color="danger" onClick={onClose} />
          <Button title="Gem" color="confirmation" onClick={onSubmit} loading={saving} loadingText="Gemmer..." />
        </div>
      </div>
    </Modal>
  )
}

export default KampdagMatchModal
